/**
 * @generated SignedSource<<e729ba804faa7e17b9845b4fa1eb6903>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalFocusScreenListHeader_widgetSignalOverview$data = {
  readonly teams: ReadonlyArray<{
    readonly name: string;
  }>;
  readonly title: string;
  readonly " $fragmentType": "SignalFocusScreenListHeader_widgetSignalOverview";
};
export type SignalFocusScreenListHeader_widgetSignalOverview$key = {
  readonly " $data"?: SignalFocusScreenListHeader_widgetSignalOverview$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignalFocusScreenListHeader_widgetSignalOverview">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignalFocusScreenListHeader_widgetSignalOverview",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetSignalOverview",
  "abstractKey": null
};

(node as any).hash = "5b08d0d08f4cb332a2eb77226ce82fdd";

export default node;
